export default defineNuxtRouteMiddleware(async (to) => {
  if (localStorage.getItem("toggleList")) {
    usePublicInfoStore().$patch((state) => {
      state.toggleList = JSON.parse(localStorage.getItem("toggleList")) || {};
    });
  }
  if (localStorage.getItem("courseList")) {
    useBelajarWajibReaderStore().$patch((state) => {
      state.courseList = JSON.parse(localStorage.getItem("courseList")) || [];
    });
  }

  if (to.path.startsWith("/portal-pembelajaran/orientasi-PPPK")) {
    const isToggleAvailable = useToggleCheck("SWAJAR");

    if (isToggleAvailable) {
      return navigateTo({
        path: "/maintenance",
        query: { page: "SWAJAR" },
      });
    }
  }
  if (to.path.startsWith("/revamp/portal-pembelajaran/swajar")) {
    const isToggleAvailable = useToggleCheck("ORIENTASI_CPNS");

    if (isToggleAvailable) {
      return navigateTo({
        path: "/maintenance",
        query: { page: "ORIENTASI_CPNS" },
      });
    }
  }
});
